/**
 * Semantic colors used to present device and panel state on a floor plan.
 * Keep vendor payload colors intact when they are supplied by the API; these
 * values are only the UI fallbacks used when a payload has no color.
 */
export const PLANE_COLORS = Object.freeze({
  alarm: '#cf1111',
  activeAlarmIcon: '#ff0000',
  warning: '#f0ad4e',
  armed: '#ff9900',
  normal: '#28a745',
  offline: '#6c757d',
  defaultIcon: '#9e9e9e',
  bypass: '#ffe200',
  textOnColor: '#ffffff',
})

/**
 * Maps normalized device states to the color that represents them in the UI.
 */
export const STATUS_COLOR_GROUPS = Object.freeze({
  alarm: ['ALARMED', 'BURGLARY', 'ALARM', 'FAULT'],
  armed: ['ARMED'],
  normal: ['DISARMED', 'NORMAL', 'RESTORED', 'ONLINE'],
  warning: ['BYPASSED', 'OPEN', 'SHORT', 'MISSING', 'UNASSIGNED', 'RESISTOR 2', 'RESISTOR 3', 'TROUBLE'],
  offline: ['OFFLINE'],
})
